export const extractStyles = (stylePropMap, props) => {
    return Object.entries(props).reduce((style, [key, value]) => {
        if (key in stylePropMap) {
            style[stylePropMap[key]] = value;
        }
        return style;
    }, {});
};
